import { render, staticRenderFns } from "./good_card.mpx?vue&type=template&id=16fcc260&scoped=true&component=true&componentId=good_card27e1a7cd"
import script from "./good_card.mpx?vue&type=script&lang=js&component=true&componentId=good_card27e1a7cd"
export * from "./good_card.mpx?vue&type=script&lang=js&component=true&componentId=good_card27e1a7cd"
import style0 from "./good_card.mpx?vue&type=style&index=0&id=16fcc260&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m27e1a7cd%22%7D&component=true&componentId=good_card27e1a7cd"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fcc260",
  null
  
)

export default component.exports